import React from 'react';

const ConfirmModal = ({
  isOpen,
  title = "Are you sure?",
  message = "Are you sure you want to go back? Any unsaved changes will be lost.",
  confirmText = "Yes, Go Back",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  icon = "bi-exclamation-triangle-fill",
  variant = "warning"
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    warning: {
      iconBg: "bg-amber-100",
      iconColor: "text-amber-600",
      confirmBtn: "bg-amber-600 hover:bg-amber-700 text-white"
    },
    danger: {
      iconBg: "bg-red-100",
      iconColor: "text-red-600",
      confirmBtn: "bg-red-600 hover:bg-red-700 text-white"
    },
    info: {
      iconBg: "bg-blue-100",
      iconColor: "text-blue-600",
      confirmBtn: "bg-[#009ef7] hover:bg-[#009ef7]/90 text-white"
    }
  };

  const currentVariant = variantStyles[variant] || variantStyles.warning;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" 
        onClick={onCancel}
      />

      {/* Modal Dialog */}
      <div className="flex min-h-full items-center justify-center p-4 text-center">
        <div className="relative transform overflow-hidden rounded-2xl bg-white text-left align-middle shadow-xl transition-all w-full max-w-md p-6">
          <div className="flex items-start gap-4">
            <div className={`flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full ${currentVariant.iconBg}`}>
              <i className={`bi ${icon} text-xl ${currentVariant.iconColor}`}></i>
            </div>
            <div className="mt-0.5 flex-1">
              <h3 className="text-lg font-semibold text-slate-900">
                {title}
              </h3>
              <p className="mt-2 text-sm text-slate-600 leading-relaxed">
                {message}
              </p>
            </div>
          </div>

          <div className="mt-6 flex flex-col-reverse sm:flex-row sm:justify-end gap-2 sm:gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="w-full sm:w-auto px-4 py-2.5 rounded-xl border border-slate-300 text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
            >
              {cancelText}
            </button>
            <button
              type="button"
              onClick={onConfirm}
              className={`w-full sm:w-auto px-4 py-2.5 rounded-xl text-sm font-semibold transition-colors shadow-sm ${currentVariant.confirmBtn}`}
            >
              {confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
